import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { openNotification } from '../UI';
import { CreateFileAttachmentInput, DeleteFileAttachmentInput } from '../generated/graphql';
import { clientCreateFileAttachment, clientDeleteFileAttachment, useGraphqlClient } from '../graphql';
import { fileAttachmentQueryKeys } from './queryKeys';

export const useCreateFileAttachment = () => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();
  const { t: tFileAttachment } = useTranslation('fileAttachment');

  const createFileAttachment = useMutation({
    mutationFn: (input: CreateFileAttachmentInput) => clientCreateFileAttachment(gqlClient, input),
    onError: () => {
      openNotification({
        type: 'error',
        description: tFileAttachment('error-unable-to-create'),
      });
    },
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries(
        fileAttachmentQueryKeys.fileAttachments(input.tenantID, input.fileAttachment.itemID)
      );
    },
  });

  return {
    createFileAttachment,
    createFileAttachmentMutation: createFileAttachment,
  };
};

export const useDeleteFileAttachment = (itemID: string | undefined | null) => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();
  const { t: tFileAttachment } = useTranslation('fileAttachment');

  const deleteFileAttachment = useMutation({
    mutationFn: (input: DeleteFileAttachmentInput) => {
      return clientDeleteFileAttachment(gqlClient, input);
    },
    onError: () => {
      openNotification({
        type: 'error',
        description: tFileAttachment('error-unable-to-delete'),
      });
    },
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries(fileAttachmentQueryKeys.fileAttachments(input.tenantID, itemID));
    },
  });

  return {
    deleteFileAttachment,
    deleteFileAttachmentMutation: deleteFileAttachment,
  };
};
